<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  maxWidth: {
    type: String,
    default: '420px'
  }
});

const emit = defineEmits(['close']);

const closeModal = () => {
  emit('close');
};

const handleOverlayClick = (e) => {
  if (e.target === e.currentTarget) {
    closeModal();
  }
};
</script>

<template>
  <Teleport to="ion-app">
    <Transition name="modal-fade">
      <div
        v-if="isOpen"
        class="kiwish-modal-overlay"
        @click="handleOverlayClick"
      >
        <div
          class="kiwish-modal-container"
          :style="{ maxWidth: maxWidth }"
        >
          <!-- Close button fixed at top -->
          <button class="kiwish-modal-close" @click="closeModal" type="button">
            <ion-icon icon="close-outline"></ion-icon>
          </button>

          <!-- Scrollable content -->
          <div class="kiwish-modal-content">
            <!-- Optional title -->
            <div v-if="title" class="kiwish-modal-title">
              <ion-text class="m19">{{ title }}</ion-text>
            </div>

            <!-- Slot for custom content -->
            <slot></slot>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.kiwish-modal-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  z-index: 19999;
  padding: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}


.kiwish-modal-container {
  background: var(--bg-card, #F8E9BF);
  background-color: var(--bg-card, #F8E9BF);
  border-radius: 16px;
  -webkit-border-radius: 16px;
  width: 100%;
  max-height: 85vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  position: relative;
  -webkit-box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.kiwish-modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
  min-width: 44px;
  min-height: 44px;
}

.kiwish-modal-close:hover {
  background: rgba(255, 82, 135, 0.1);
}

.kiwish-modal-close:active {
  background: rgba(255, 82, 135, 0.2);
}

.kiwish-modal-close ion-icon {
  font-size: 28px;
  color: #FF5287;
}

.kiwish-modal-content {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 20px;
  padding-top: 50px;
  padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
}

.kiwish-modal-content::-webkit-scrollbar {
  width: 4px;
}

.kiwish-modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.kiwish-modal-content::-webkit-scrollbar-thumb {
  background: rgba(255, 82, 135, 0.3);
  border-radius: 4px;
}

.kiwish-modal-title {
  text-align: center;
  margin-bottom: 20px;
}

.kiwish-modal-title ion-text {
  color: #5A695B;
  font-weight: 600;
}

/* Transition animations */
.modal-fade-enter-active,
.modal-fade-leave-active {
  -webkit-transition: opacity 0.25s ease;
  transition: opacity 0.25s ease;
}

.modal-fade-enter-active .kiwish-modal-container,
.modal-fade-leave-active .kiwish-modal-container {
  -webkit-transition: transform 0.25s ease, opacity 0.25s ease;
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-from .kiwish-modal-container,
.modal-fade-leave-to .kiwish-modal-container {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
  opacity: 0;
}
</style>

<style>
/* En web, menos margen lateral (no scoped para acceder a .web-app del body) */
.web-app .kiwish-modal-overlay {
  padding: 5px !important;
}
</style>
